import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "tabs-underline__menu" }

import { toRefs, ref, onMounted, computed, watch } from 'vue'
import ListStandard from './ListStandard.vue'
import TabsUnderline from '../atoms/TabsUnderline.vue'

interface EMITS {
  (e: 'select', item: Object): void
}

export default /*@__PURE__*/_defineComponent({
  __name: 'TabsUnderlineMenu',
  props: {
  tabItems: {
    type: Object,
    default: () => {}
  },
  isLoading: {
    type: Boolean,
    default: false
  },
  searchString: {
    type: String,
    default: ''
  }
},
  emits: ["select"],
  setup(__props, { emit: __emit }) {

const props = __props
const { tabItems, searchString } = toRefs(props)
// Emits (defineEmits)
const emits = __emit
// Reactive variables etc
const tabMenuRef = ref<HTMLElement | null>(null)
const tabContentRef = ref<HTMLElement | null>(null)
// computed
const totalResultsCount = computed(() => {
  let totalCount = 0
  tabItems.value.forEach((tab) => {
    totalCount += tab.items.length
  })
  return totalCount
})
// methods
function onSelect(item: Object) {
  emits('select', item)
}
function toggleActiveContent(clickedTab: string) {
  const currentActive = document.querySelectorAll(
    '.tabs-underline__content[active], .tab-underline[active]'
  )
  const newActive = document.querySelector(`#${clickedTab}`)
  if (currentActive) currentActive.forEach((el) => el.toggleAttribute('active'))
  if (newActive) newActive.toggleAttribute('active')
}

watch(searchString, (newVal, oldVal) => {
  if (newVal !== oldVal) {
    tabMenuRef.value?.firstElementChild?.toggleAttribute('active')
    tabContentRef.value?.firstElementChild?.toggleAttribute('active')
  }
})
watch(tabContentRef, (newVal) => {
  if (newVal) tabContentRef.value?.firstElementChild?.toggleAttribute('active')
})

// lifecycle hooks
onMounted(() => {
  tabMenuRef.value?.firstElementChild?.toggleAttribute('active')
  tabContentRef.value?.firstElementChild?.toggleAttribute('active')
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        ref_key: "tabMenuRef",
        ref: tabMenuRef,
        class: "tabs-underline__menu-wrapper"
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tabItems), (tabItem, index) => {
          return (_openBlock(), _createBlock(TabsUnderline, {
            key: 'tabItem-' + index,
            tabText: tabItem.title,
            tabIcon: tabItem.icon,
            amount: __props.isLoading ? '-' : tabItem.items.length,
            onToggleActiveTab: toggleActiveContent
          }, null, 8, ["tabText", "tabIcon", "amount"]))
        }), 128))
      ], 512)
    ]),
    (totalResultsCount.value > 0)
      ? _withDirectives((_openBlock(), _createElementBlock("div", {
          key: 0,
          ref_key: "tabContentRef",
          ref: tabContentRef,
          class: "tabs-underline__content-wrapper"
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tabItems), (tabItem, index) => {
            return (_openBlock(), _createBlock(ListStandard, {
              id: tabItem.title,
              key: `tab-${index}`,
              class: "tabs-underline__content",
              icon: tabItem.icon,
              items: tabItem.items,
              searchString: _unref(searchString),
              onSelect: onSelect
            }, null, 8, ["id", "icon", "items", "searchString"]))
          }), 128))
        ], 512)), [
          [_vShow, !__props.isLoading]
        ])
      : _createCommentVNode("", true)
  ], 64))
}
}

})